import { cn } from "@/lib/utils"
import * as React from "react"
import { HTMLAttributes } from "react"

interface GradientTextProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Array of colors for the gradient
   * @default ["#ffd6d9", "#ff4d4f", "#ffd6d9"]
   */
  colors?: string[]
  /**
   * Animation duration in seconds
   * @default 8
   */
  animationSpeed?: number
  /**
   * Show animated border
   * @default false
   */
  showBorder?: boolean
}

export function GradientText({
  children,
  className,
  colors = ["hsl(var(--color-1))", "hsl(var(--color-2))", "hsl(var(--color-3))", "hsl(var(--color-4))", "hsl(var(--color-5))", "hsl(var(--color-1))", "hsl(var(--color-2))", "hsl(var(--color-3))"],
  animationSpeed = 8,
  showBorder = false,
  ...props
}: GradientTextProps) {
  const gradientStyle = {
    backgroundImage: `linear-gradient(to right, ${colors.join(", ")})`,
    animationDuration: `${animationSpeed}s`,
  }

  return (
    <div
      className={cn(
        "relative w-full flex flex-row items-center justify-start",
        "font-medium transition-shadow duration-500",
        className
      )}
      {...props}
    >
      {showBorder && (
        <div
          className="absolute inset-0 bg-cover z-0 pointer-events-none animate-gradient"
          style={{
            ...gradientStyle,
            backgroundSize: "300% 100%",
          }}
        >
          <div
            className="absolute inset-0 bg-background rounded-[1.25rem] z-[-1]"
            style={{
              width: "calc(100% - 2px)",
              height: "calc(100% - 2px)",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        </div>
      )}
      <div
        className="inline-block relative z-2 text-transparent bg-cover animate-gradient w-full py-1 leading-tight"
        style={{
          ...gradientStyle,
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          backgroundSize: "200% 100%",
          backgroundPosition: "0% 50%",
        }}
      >
        {children}
      </div>
    </div>
  )
}